import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const checkoutAttributesUpdate = (
	`mutation checkoutAttributesUpdateV2($checkoutId: ID!, $input: CheckoutAttributesUpdateV2Input!) {
		checkoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutAttributesUpdate;
